import React from 'react'

import { useUser } from '../../UserContext'
import LoadingComponent from '../LoadingComponent'
import Sidebar from '../Sidebar/Sidebar'

const Layout = () => {
  const { user, loading } = useUser()

  if (loading) return <LoadingComponent />
  return <div>{user && <Sidebar user={user} />}</div>
}

export default Layout
